import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Data } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { SocialService } from "src/app/services/social.service";
import { NgClass, NgStyle, AsyncPipe } from "@angular/common";

@Component({
    selector: "app-change-image-popup",
    templateUrl: "./change-image-popup.component.html",
    styleUrls: ["./change-image-popup.component.scss"],
    standalone: true,
    imports: [
        NgClass,
        NgStyle,
        AsyncPipe,
    ],
})
export class ChangeImagePopupComponent implements OnInit {
  globalFortuneMapData$ = new BehaviorSubject(null);
  timer: number;
  white: boolean;
  real_estate: object;
  garage: object;
  bucket: object;
  holiday: object;
  popup1: boolean;
  popup2: boolean;
  popup3: boolean;
  showCheck1: boolean;
  showing1: boolean;
  showCheck2: boolean;
  showing2: boolean;
  showCheck3: boolean;
  showing3: boolean;

  constructor(
    public dialogRef: MatDialogRef<ChangeImagePopupComponent>,
    private socialService: SocialService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: Data
  ) {
    this.timer = 6000;
    this.white = false;
    this.popup1 = false;
    this.popup2 = false;
    this.popup3 = false;
    this.showing1 = false;
    this.showing2 = false;
    this.showing3 = false;
    this.showCheck1 = false;
    this.showCheck2 = false;
    this.showCheck3 = false;
  }
  ngOnInit(): void {
    this.socialService
      .socialFortuneMapGlobalData()
      .then((d) => {
        if (d[3].collection == "property") {
          for (let index of Object.keys(d[3].data.levels)) {
            if (index == this.data[2]?.real_estate.level) {
              this.real_estate = d[3]?.data.levels[index];
            }
          }
        }
        if (d[1]?.collection == "garage") {
          for (let index of Object.keys(d[1].data.levels)) {
            if (index == this.data[2]?.transport?.level) {
              this.garage = d[1]?.data?.levels[index];
            }
          }
        }
        if (d[0].collection == "bucket") {
          for (let index of Object.keys(d[0].data.levels)) {
            if (index == this.data[2]?.lifestyle?.level) {
              this.bucket = d[0].data.levels[index];
            }
          }
        }
        if (d[2].collection == "holiday") {
          for (let index of Object.keys(d[2].data.levels)) {
            if (index == this.data[2]?.holiday?.level) {
              this.holiday = d[2].data.levels[index];
            }
          }
        }
        this.globalFortuneMapData$.next(d);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  triggerClick(e: string, selectedData: string, collection: string) {
    if (e == "one") {
      this.popup1 = true;
      setTimeout(() => {
        this.showCheck1 = true;
        this.showing1 = true;
      }, 2000);
    } else if (e == "two") {
      this.popup2 = true;
      setTimeout(() => {
        this.showCheck2 = true;
        this.showing2 = true;
      }, 2000);
    } else if (e == "three") {
      this.popup3 = true;
      setTimeout(() => {
        this.showCheck3 = true;
        this.showing3 = true;
      }, 2000);
    }
    setTimeout(() => {
      const alldata = { image: selectedData, collectionName: collection };
      this.dialogRef.close(alldata);
      // this.dialog.closeAll();
    }, this.timer);
  }
  getClass(e: string) {
    if (e == "two") {
      return "popup-class";
    } else {
      return "white";
    }
  }
}
